module.exports = __webpack_public_path__ + "static/media/process.50a0ea10.svg";